import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const NumberCircleFour: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m580.92 199.08c-51-51-118.8-79.08-190.92-79.08s-139.92 28.08-190.92 79.08-79.08 118.8-79.08 190.92 28.08 139.92 79.08 190.92 118.8 79.08 190.92 79.08 139.92-28.08 190.92-79.08 79.08-118.8 79.08-190.92-28.08-139.92-79.08-190.92zm-21.21 360.62c-45.33 45.33-105.6 70.29-169.71 70.29s-124.38-24.96-169.71-70.29-70.29-105.6-70.29-169.71 24.96-124.38 70.29-169.71 105.6-70.29 169.71-70.29 124.38 24.96 169.71 70.29 70.29 105.6 70.29 169.71-24.96 124.38-70.29 169.71z' />
    <path d='m447.17 257.73h-37.29l-111.86 176.99v25.35h119.81v52.2h29.33v-52.2h34.8v-27.34h-34.8v-175zm-115.84 173.01 84.52-133.74h1.99v135.72h-86.5v-1.99z' />
  </IconBase>
));

NumberCircleFour.displayName = 'NumberCircleFour';

export default NumberCircleFour;
